<template>
  <div class="menu-tab white" id="edit" ref="main">
    <div class="menu-tab-content">
      <div class="note-box" ref="addbox">
        <div class="addtabs">
          <ul class="header">
            <li :data-active="addTab === 'note'"><a href="#" @click.prevent="addTab = 'note'"><t-icon name="icon-page-left" /> Nytt notat</a></li>
            <li :data-active="addTab === 'url'"><a href="#" @click.prevent="addTab = 'url'"><t-icon name="icon-link" /> Ny lenke</a></li>
          </ul>
          <NoteForm @added="scrollToActive" class="tab" v-if="addTab === 'note'" />
          <UrlForm @added="scrollToActive" class="tab" v-if="addTab === 'url'" />
        </div>
      </div>
      <div class="book-element-list">
        <div class="page" v-for="page in pages" :key="page.pageNumber" :ref="`page${page.pageNumber}`">
          <a class="page-link" :title="`Gå til side ${page.pageNumber}`" href="#" @click.prevent="goToPage(page.pageNumber)">Side {{ page.pageNumber }}</a>
          <ul>
            <li v-for="url in page.urls" :key="`url-${url.id}`" class="url">
              <a :href="url.url" target="_blank"><t-icon name="icon-link" /> {{ formatUrlTitle(url) }}</a><a href="#" @click.prevent="deleteUrl(url.id)" class="btn delete-url-btn"><t-icon name="icon-trashcan" /></a>
            </li>
            <li v-for="note in page.notes" :key="`note-${note.id}`" class="note">
              <div class="info">{{ formatDate(note.createdTime) }} <a class="btn" @click.prevent="deleteNote(note.id)" href="#" alt="Slett"><t-icon name="icon-trashcan" /></a></div>
              <p v-html="fixLinebreaks(note.note)"></p>
            </li>
            <li v-if="page.elements.length">
              <div class="info">{{ formatDate(maxDate(page.elements)) }} <a class="btn" @click.prevent="deleteElementsByPageNumber(page.pageNumber)" href="#" alt="Slett"><t-icon name="icon-trashcan" /></a></div>
              <a href="#" @click.prevent="clickDrawing(page.pageNumber)">
                <svg class="thumb-element" width="235" height="235">
                  <SvgPath v-for="(element, index) in page.elements" :key="index" :path="element.element" :width="235" :height="235" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgPath from '@/views/page/SvgPath'
import bookTools from '@/utils/book'
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import NoteForm from './NoteForm'
import UrlForm from './UrlForm'

export default {
  data () {
    return {
      active: false,
      click: false,
      addTab: 'note'
    }
  },
  activated () {
    this.active = true
    this.scrollToActive()
  },
  deactivated () {
    this.active = false
  },
  methods: {
    maxDate (elements) {
      return _.maxBy(elements, 'createdTime').createdTime
    },
    // Replaces the `| moment(...)` template filter (removed by main.js's `vue-moment` plugin,
    // which is itself removed — Vue 3 has no template filters at all, and vue-moment was never
    // updated for Vue 3). Same format string as before.
    formatDate (value) {
      return moment(value).format('ddd DD. MMMM YYYY hh:mm')
    },
    ...mapActions(['deleteElementsByPageNumber', 'deleteNote', 'deleteUrl', 'setDrawMode']),
    fixLinebreaks (value) {
      return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    formatUrlTitle (url) {
      if (url.title) {
        return url.title
      } else if (url.url.length > 30) {
        return url.url.substring(0, 25) + '...'
      }

      return url.url
    },
    scrollToActive () {
      let pageNumber = this.pageNumber
      if (!bookTools.isEven(pageNumber)) {
        pageNumber = pageNumber - 1
      }
      const closestPageNumber = bookTools.closestNumber(pageNumber, this.pageNumbers)
      if (closestPageNumber) {
        const el = (this.$refs[`page${closestPageNumber}`] || [])[0]
        if (el !== null || el !== undefined) {
          this.$refs.main.scrollTop = el.offsetTop
          if (this.$refs.main.scrollTop === el.offsetTop) {
            this.$refs.main.scrollTop -= this.$refs.addbox.offsetHeight
          }
        }
      }
    },
    clickDrawing (pageNumber) {
      this.click = true
      this.$router.push({ params: { pageNumber } })
      this.setDrawMode('view')
    },
    goToPage (pageNumber) {
      this.click = true
      this.$router.push({ params: { pageNumber } })
    }
  },
  computed: {
    pages () {
      return this.$store.getters.pages.map(p => {
        return {
          pageNumber: p.pageNumber,
          elements: this.$store.getters.elements.filter(e => e.pageNumber === p.pageNumber),
          notes: this.$store.getters.notes.filter(e => e.pageNumber === p.pageNumber),
          urls: this.$store.getters.urls.filter(u => u.pageNumber === p.pageNumber)
        }
      }).filter(p => p.elements.length > 0 || p.notes.length > 0 || p.urls.length > 0)
    },
    pageNumber () {
      return this.$route.params.pageNumber
    },
    pageNumbers () {
      return _.sortBy(this.pages, ['pageNumber']).map(p => p.pageNumber)
    }
  },
  watch: {
    '$store.getters.leftMenuOpen' (newVal) {
      if (newVal && this.active) {
        this.scrollToActive()
      }
    },
    pageNumber () {
      if (this.active && !this.click) {
        setTimeout(() => {
          this.scrollToActive()
        }, 100)
      }

      this.click = false
    }
  },
  components: {
    SvgPath,
    NoteForm,
    UrlForm
  }
}
</script>

<style lang="scss">
  @use "../style/variables" as *;
  .note-box {
    position: sticky;
    top: 0px;
    z-index: 1;
    background-color: #EFEFEF;
    margin: -10px -20px 0 -20px;
    color: #333;
  }
  .addtabs {
    padding: 10px;
    .header {
      font-size: 14px;
      padding: 0;
      list-style-type: none;
      margin-bottom: 15px;
      li {
        margin-right: 6px;
        padding: 8px 8px;
        display: inline-block;
        background-color: #CCC;
        font-weight: 800;
        border-radius: 4px;
        &[data-active="true"] {
          background-color: $lightgreen;
          box-shadow: #CCC 2px 2px 5px;
        }
        a {
          color: inherit;
        }
      }
    }
    .tab {
      font-size: 14px;
      .text-input {
        border: 0;
        display: block;
        width: 100%;
        height: 26.5px;
        padding: 3px;
        &:last-child {
          margin-bottom: 8px;
        }
      }
      .note-text {
        height: 100px;
        width: 100%;
        border: 0;
      }

      .page-btn {
        .label {
          margin-right: 20px;
          font-weight: 800;
        }
        text-align: right;
        margin-top: 8px;
        button {
          background-color: #CCC;
          border-radius: 2px;
          border: 0;
          padding: 5px 10px;
          font-size: 19px;
          &:last-child {
            margin-left: 6px;
          }
          &:hover {
            background-color: $lightgreen;
          }
        }
      }
    }
  }
  .thumb-element {
    border: 1px solid #DEDEDE;
  }
  .info {
    font-size: 12px;
    text-align: right;
    margin-bottom: 10px;
  }
  .add-btn {
    float: right;
    background-color: green;
    border: 0;
    padding: 3px 5px;
    font-size: 12px;
    color: #FFF;
    border-radius: 3px;
  }
  .note {
    font-size: 13px;
  }
  .url {
    position: relative;
  }
  .delete-url-btn {
    position: absolute;
    right: 0;
    top: 15px;
  }
</style>
